// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent_card {
  background-color: #f2f2f2;
  font-size: 12px;
}

.agent_feild {
  float: left;
  width: 100%;
}

.agent_type_feild {
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  top: -6px;
}

.agent_type {
  width: 100%;
  height: 30px;
  position: relative;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {
  height: 0px !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {
  top: 0;
  height: 0px !important;
  overflow: hidden;
}

.active_card {
  border-left: 4px solid #07a36e;
}

.failed_card {
  border-left: 4px solid #da606c;
}

.active_cardcolor {
  border-left: 4px solid #07a36e;
  background-color: #C3EFF4;
}

.failed_cardcolor {
  border-left: 4px solid #da606c;
  background-color: #C3EFF4;
}

.agent_name_text {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
}

::ng-deep.eventinfo-modal-edit .modal-dialog {
  max-width: 71% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important; /* Center horizontally */
  padding: 0 !important;
}

::ng-deep.eventinfo-modal-edit {
  top: 43% !important; /* Move to the vertical center */
  transform: translateY(-50%) !important; /* Adjust for the modal's height */
}

::ng-deep.eventinfo-modal-add .modal-dialog {
  max-width: 71% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important; /* Center horizontally */
  padding: 0 !important;
}

::ng-deep.eventinfo-modal-add {
  top: 43% !important; /* Move to the vertical center */
  transform: translateY(-50%) !important; /* Adjust for the modal's height */
}

.agent_form_field {
  width: 100%;
}

.agent_form_field input {
  font-size: 12px !important;
}

.active_mode {
  color: #07a36e;
}

.testing_mode {
  color: #f2f2f2;
}

::ng-deep.mat-form-field .mat-form-field-wrapper {
  padding-bottom: 1%;
}

.configtable td {
  padding: 1% !important;
}

.configtable tr:hover {
  background-color: #f3eded;
  cursor: pointer;
}

.agent_title {
  color: #0c0c0c;
  text-align: initial;
  font-size: 12px !important;
  font-weight: 700;
}

.text-ellipsis {
  max-width: 83%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-truncate {
  overflow: hidden; /* Hide overflowing text */
  text-overflow: ellipsis; /* Add ellipsis (...) for truncated text */
  white-space: nowrap; /* Prevent text from wrapping to the next line */
}

.active_table {
  background-color: rgba(23, 162, 184, 0.231372549);
}

.agent_text {
  color: black;
  top: 7px;
}

.copy_icon {
  background-repeat: no-repeat;
  display: inline-block;
  fill: currentColor;
  height: 24px;
  width: 24px;
  font-size: 18px;
  position: relative;
  top: 8%;
  left: 2%;
  cursor: pointer;
}

::ng-deep.agent_form_field .mat-form-field-empty.mat-form-field-label {
  display: block;
  position: relative !important;
  top: 7px !important;
}

::ng-deep.agent_form_field.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  transform: translateY(-1.59375em) scale(0.75);
  width: 133.33333%;
  position: relative;
  top: 13px !important;
}

.agent_form_field {
  width: 100%;
}

.agent_form_field input {
  font-size: 12px !important;
}

::ng-deep.agent_form_field .mat-form-field-infix {
  padding: 0% !important;
  padding-bottom: 7px !important;
  padding-top: 2px !important;
}

.addconfigbtn {
  background-color: #17a0b4 !important;
  font-size: 12px !important;
  color: white;
  height: 28px !important;
  line-height: 20px;
  right: 1%;
  top: 0%;
  cursor: pointer;
}

.selectpipeline {
  width: 87%;
}

.notselectedpipeline {
  width: 76%;
}

.autocomplete-container {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  position: relative !important;
  overflow: visible !important;
  height: 31px !important;
  border-radius: 5px !important;
  display: flex; /* Align items properly */
  align-items: center; /* Center items vertically */
  width: 100%; /* Ensure it takes the full width of the parent */
  background-color: white;
}

.autocomplete-container input {
  width: 100%; /* Ensure the input takes the full width of the container */
  box-shadow: none; /* Remove any default shadow */
  border: 1px solid #ccc; /* Add a consistent border */
  border-radius: 4px; /* Add rounded corners */
  padding: 8px; /* Add padding for better spacing */
  font-family: sans-serif;
  font-size: 11px !important;
  border: 0px !important;
  height: 14px !important;
}

.agentedit {
  position: relative;
  overflow-x: hidden;
  height: 86vh;
}

::ng-deep.agmatoutlinestyles.mat-mdc-form-field {
  width: 100%;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mdc-text-field--outlined {
  padding: 6px !important;
  height: 31px !important;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex {
  height: 30px !important;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mdc-notched-outline .mdc-floating-label {
  font-size: 11px !important;
  padding-bottom: 24px;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-input-element {
  position: relative;
  font-size: 12px !important;
  bottom: 8px !important;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  bottom: 11px !important;
}

::ng-deep.agmatoutlinestyles.dateicon .mat-mdc-form-field-icon-suffix {
  bottom: 5px !important;
}

::ng-deep.agmatoutlinestyles .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}

#eventTypeInput::placeholder {
  color: #6c757d; /* Match the placeholder color of ng-autocomplete */
  opacity: 1; /* Ensure the placeholder is fully visible */
}`, "",{"version":3,"sources":["webpack://./src/app/eventinfo/eventinfo.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AACA;EACI,yBAAA;EAA0B,eAAA;AAC9B;;AACI;EACI,WAAA;EACA,WAAA;AAER;;AACM;EACE,WAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAER;;AAAM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAGR;;AAAM;EACE,sBAAA;AAGR;;AAAM;EACE,MAAA;EACA,sBAAA;EACA,gBAAA;AAGR;;AAAM;EACE,8BAAA;AAGR;;AADM;EACE,8BAAA;AAIR;;AADM;EACE,8BAAA;EAEA,yBAAA;AAGR;;AAAM;EACE,8BAAA;EAEA,yBAAA;AAER;;AACM;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AAER;;AACM;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA,EAAA,wBAAA;EACA,qBAAA;AAER;;AAAM;EACE,mBAAA,EAAA,gCAAA;EACA,sCAAA,EAAA,kCAAA;AAGR;;AADM;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA,EAAA,wBAAA;EACA,qBAAA;AAIR;;AADM;EACE,mBAAA,EAAA,gCAAA;EACA,sCAAA,EAAA,kCAAA;AAIR;;AAFM;EACE,WAAA;AAKR;;AAFM;EACE,0BAAA;AAKR;;AAHM;EACE,cAAA;AAMR;;AAJM;EACE,cAAA;AAOR;;AALM;EACE,kBAAA;AAQR;;AANM;EACE,sBAAA;AASR;;AAPM;EACE,yBAAA;EACA,eAAA;AAUR;;AAPI;EACE,cAAA;EAAe,mBAAA;EAAmB,0BC3G7B;ED2GiD,gBAAA;AAa5D;;AAVI;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAaN;;AAVE;EACE,gBAAA,EAAA,0BAAA;EACA,uBAAA,EAAA,0CAAA;EACA,mBAAA,EAAA,gDAAA;AAaJ;;AAVE;EACE,iDAAA;AAaJ;;AAXE;EACE,YAAA;EACE,QAAA;AAcN;;AAZE;EACE,4BAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;AAeJ;;AAbE;EACE,cAAA;EACA,6BAAA;EACA,mBAAA;AAgBJ;;AAbE;EACE,6CAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AAgBJ;;AAdE;EACE,WAAA;AAiBJ;;AAdE;EACE,0BAAA;AAiBJ;;AAfE;EACE,sBAAA;EACA,8BAAA;EACA,2BAAA;AAkBJ;;AAhBE;EACE,oCCxKQ;EDyKR,0BCxKO;EDyKP,YAAA;EACA,uBCxKQ;EDyKR,iBAAA;EACA,SAAA;EACA,OAAA;EACA,eAAA;AAmBJ;;AAjBE;EACE,UAAA;AAoBJ;;AAlBE;EACE,UAAA;AAqBJ;;AAnBE;EACE,oDAAA;EACA,6BAAA;EACA,4BAAA;EACA,uBAAA;EACA,6BAAA;EACA,aAAA,EAAA,yBAAA;EACF,mBAAA,EAAA,4BAAA;EACA,WAAA,EAAA,iDAAA;EACA,uBAAA;AAsBF;;AAnBA;EACE,WAAA,EAAA,2DAAA;EACA,gBAAA,EAAA,8BAAA;EACA,sBAAA,EAAA,4BAAA;EACA,kBAAA,EAAA,wBAAA;EACA,YAAA,EAAA,mCAAA;EACA,uBAAA;EACE,0BAAA;EACF,sBAAA;EACA,uBAAA;AAsBF;;AApBA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;AAuBF;;AApBA;EACE,WAAA;AAuBF;AAtBE;EACE,uBAAA;EACA,uBAAA;AAwBJ;AArBI;EACE,uBAAA;AAuBN;AAtBM;EACI,0BAAA;EACA,oBAAA;AAwBV;AAtBM;EACE,kBAAA;EACA,0BAAA;EACA,sBAAA;AAwBR;AAtBM;EACE,uBAAA;AAwBR;;AAnBA;EACA,sBAAA;AAsBA;;AAnBE;EACE,wBAAA;AAsBJ;;AAlBA;EACE,cAAA,EAAA,mDAAA;EAEA,UAAA,EAAA,4CAAA;AAoBF","sourcesContent":["@import \"../../variables.scss\";\r\n.parent_card{\r\n    background-color:#f2f2f2; font-size: 12px;\r\n    }\r\n    .agent_feild {\r\n        float: left;\r\n        width: 100%;\r\n      }\r\n\r\n      .agent_type_feild {\r\n        width: 100%;\r\n        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n        border-radius: 5px;\r\n        padding-inline: 1%;\r\n        top: -6px;\r\n      }\r\n      .agent_type {\r\n        width: 100%;\r\n        height: 30px;\r\n        position: relative;\r\n      }\r\n\r\n      ::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline{\r\n        height: 0px !important;\r\n      }\r\n\r\n      ::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {\r\n        top: 0;\r\n        height: 0px !important;\r\n        overflow: hidden;\r\n      }\r\n\r\n      .active_card {\r\n        border-left: 4px solid #07a36e;\r\n      }\r\n      .failed_card {\r\n        border-left: 4px solid #da606c;\r\n      }\r\n\r\n      .active_cardcolor{\r\n        border-left: 4px solid #07a36e;\r\n        // width: 99%;\r\n        background-color: #C3EFF4;\r\n      }\r\n\r\n      .failed_cardcolor {\r\n        border-left: 4px solid #da606c;\r\n        //width: 99%;\r\n        background-color: #C3EFF4;\r\n      }\r\n      \r\n      .agent_name_text{\r\n        font-size: 12px;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        max-width: 90% !important;\r\n        display: inline-block;\r\n      }\r\n\r\n      ::ng-deep.eventinfo-modal-edit .modal-dialog {\r\n        max-width: 71% !important;\r\n        max-height: 60% !important;\r\n        height: 60% !important;\r\n        margin: auto !important; /* Center horizontally */\r\n        padding: 0 !important;\r\n      }\r\n      ::ng-deep.eventinfo-modal-edit{\r\n        top: 43% !important; /* Move to the vertical center */\r\n        transform: translateY(-50%) !important; /* Adjust for the modal's height */\r\n      }\r\n      ::ng-deep.eventinfo-modal-add .modal-dialog {\r\n        max-width: 71% !important;\r\n        max-height: 60% !important;\r\n        height: 60% !important;\r\n        margin: auto !important; /* Center horizontally */\r\n        padding: 0 !important;\r\n       \r\n      }\r\n      ::ng-deep.eventinfo-modal-add {\r\n        top: 43% !important; /* Move to the vertical center */\r\n        transform: translateY(-50%) !important; /* Adjust for the modal's height */\r\n      }\r\n      .agent_form_field{\r\n        width: 100%;\r\n\r\n      }\r\n      .agent_form_field input{\r\n        font-size: 12px!important;\r\n      }\r\n      .active_mode{\r\n        color: #07a36e;\r\n      }\r\n      .testing_mode{\r\n        color:#f2f2f2;\r\n      }\r\n      ::ng-deep.mat-form-field .mat-form-field-wrapper{\r\n        padding-bottom: 1%;\r\n      }\r\n      .configtable td{\r\n        padding: 1%!important;\r\n      }\r\n      .configtable tr:hover {\r\n        background-color: #f3eded;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .agent_title{\r\n      color: #0c0c0c;text-align:initial;font-size:$fontsize;font-weight: 700;\r\n    }\r\n\r\n    .text-ellipsis{\r\n      max-width: 83%;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n      white-space: nowrap;\r\n  }\r\n\r\n  .text-truncate {\r\n    overflow: hidden; /* Hide overflowing text */\r\n    text-overflow: ellipsis; /* Add ellipsis (...) for truncated text */\r\n    white-space: nowrap; /* Prevent text from wrapping to the next line */\r\n  }\r\n\r\n  .active_table{\r\n    background-color: #17a2b83b;\r\n  }\r\n  .agent_text{\r\n    color: black;\r\n      top: 7px;\r\n  }\r\n  .copy_icon{\r\n    background-repeat: no-repeat;\r\n    display: inline-block;\r\n    fill: currentColor;\r\n    height: 24px;\r\n    width: 24px;\r\n    font-size: 18px;\r\n    position: relative;\r\n    top: 8%;\r\n    left: 2%;\r\n    cursor: pointer;\r\n  }\r\n  ::ng-deep.agent_form_field .mat-form-field-empty.mat-form-field-label {\r\n    display: block;\r\n    position: relative !important;\r\n    top: 7px !important;\r\n  }\r\n\r\n  ::ng-deep.agent_form_field.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {\r\n    transform: translateY(-1.59375em) scale(.75);\r\n    width: 133.33333%;\r\n    position: relative;\r\n    top: 13px !important;\r\n  }\r\n  .agent_form_field{\r\n    width: 100%;\r\n\r\n  }\r\n  .agent_form_field input{\r\n    font-size: 12px!important;\r\n  }\r\n  ::ng-deep.agent_form_field .mat-form-field-infix{\r\n    padding: 0%!important;\r\n    padding-bottom: 7px!important;\r\n    padding-top: 2px!important;\r\n  }\r\n  .addconfigbtn{\r\n    background-color:$btn-color;\r\n    font-size: $fontsize;\r\n    color:white ;\r\n    height: $btnHeight;\r\n    line-height: 20px;\r\n    right: 1%;\r\n    top: 0%;\r\n    cursor: pointer;\r\n  }\r\n  .selectpipeline{\r\n    width:87%;\r\n  }\r\n  .notselectedpipeline{\r\n    width:76%;\r\n  }\r\n  .autocomplete-container {\r\n    box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    position: relative !important;\r\n    overflow: visible !important;\r\n    height: 31px !important;\r\n    border-radius: 5px !important;\r\n    display: flex; /* Align items properly */\r\n  align-items: center; /* Center items vertically */\r\n  width: 100%; /* Ensure it takes the full width of the parent */\r\n  background-color: white;\r\n}\r\n\r\n.autocomplete-container input {\r\n  width: 100%; /* Ensure the input takes the full width of the container */\r\n  box-shadow: none; /* Remove any default shadow */\r\n  border: 1px solid #ccc; /* Add a consistent border */\r\n  border-radius: 4px; /* Add rounded corners */\r\n  padding: 8px; /* Add padding for better spacing */\r\n  font-family: sans-serif;\r\n    font-size: 11px !important;\r\n  border: 0px !important;\r\n  height: 14px !important;\r\n}\r\n.agentedit{\r\n  position: relative;\r\n  overflow-x: hidden;\r\n  height: 86vh;\r\n}\r\n\r\n::ng-deep.agmatoutlinestyles.mat-mdc-form-field{ \r\n  width: 100%;\r\n  .mdc-text-field--outlined {\r\n    padding: 6px !important;\r\n    height: 31px !important;\r\n  }\r\n  .mat-mdc-text-field-wrapper{\r\n    .mat-mdc-form-field-flex {\r\n      height: 30px !important;\r\n      .mdc-notched-outline .mdc-floating-label{\r\n          font-size: 11px !important;\r\n          padding-bottom: 24px;\r\n      }\r\n      .mat-mdc-input-element{\r\n        position: relative;\r\n        font-size: 12px !important;\r\n        bottom: 8px !important;\r\n      }\r\n      .mat-mdc-form-field-infix{\r\n        bottom: 11px !important;\r\n      }\r\n    }\r\n }\r\n}\r\n::ng-deep.agmatoutlinestyles.dateicon .mat-mdc-form-field-icon-suffix{\r\nbottom: 5px !important;\r\n}\r\n::ng-deep.agmatoutlinestyles{\r\n  .mat-mdc-form-field-subscript-wrapper{\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n#eventTypeInput::placeholder {\r\n  color: #6c757d; /* Match the placeholder color of ng-autocomplete */\r\n  \r\n  opacity: 1; /* Ensure the placeholder is fully visible */\r\n}\r\n","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
